module.exports = __webpack_public_path__ + "assets/img/ExtractOne_btn.4ab0bfc9.png";